import { Typography, Box } from '@mui/material';
import { PlatformType } from '@okletsplay/core';
import { CHESS_DRAUGHTS_CLOCK_OPTIONS } from 'modules/games/constants';
import { gamesSelectorFactory } from 'modules/games/store/games/selectors';
import { MatchFormFields } from 'modules/matches/interfaces/forms';
import React, { FC, useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { SelectInput } from 'shared/components/Form/SelectInput';

export const CheckersChessMatchSettingsForm: FC = () => {
  const { setValue, watch } = useFormContext<MatchFormFields>();
  const clockIncrement = watch('clockIncrement') ?? 0;
  const clockLimit = watch('clockLimit') ?? 0;
  const gameId = watch('gameId');

  const selectedGame = useSelector(gamesSelectorFactory.useById(gameId));

  const activeOption = useMemo(() => {
    return JSON.stringify({ clockLimit, clockIncrement });
  }, [clockLimit, clockIncrement]);

  const onChangeHandler = useCallback(
    (value) => {
      const data = JSON.parse(value);

      setValue('clockLimit', data.clockLimit, { shouldValidate: true });
      setValue('clockIncrement', data.clockIncrement, { shouldValidate: true });
    },
    [setValue]
  );

  if (
    !selectedGame ||
    ![PlatformType.Lichess, PlatformType.Lidraughts].includes(selectedGame.platformType)
  ) {
    return null;
  }

  return (
    <Box mb={2}>
      <Typography sx={{ mb: 2 }}>Timer settings</Typography>
      <SelectInput
        value={activeOption}
        onChange={onChangeHandler}
        options={CHESS_DRAUGHTS_CLOCK_OPTIONS}
      />
    </Box>
  );
};
